import React, { Component, useState, useEffect } from "react";
export default class CollectionCard extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="collection-card-outer">
        <div className="collection-card-inner">
          <div className="collection-card-img-container">
            <img
              className="collection-card-img"
              src="https://lh3.googleusercontent.com/a-/AOh14GgCKv16eFLqX2zlUH_odB7j-ycU9_weOkNdo9Lt-w"
            />
          </div>
          <div className="collection-card-title-name-container">
            <div className="collection-card-title">
              All the Roadmaps you need to excel in Web Dev 2020
            </div>
            <div className="collection-card-name">Andrew Chen</div>
          </div>
          <div className="collection-card-extra-info-container">
            <div className="collection-card-roadmap-count">17 roadmaps</div>
            <div classname="collection-card-resource-count">95 resources</div>
          </div>
        </div>
      </div>
    );
  }
}
